import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {useAssignedItems} from "utils/hooks/useAssignedItems";
import AccessTicketDriverUpsell from "./AccessTicketDriverUpsell";
import {useTypedSelector} from "helpers/reducers";

const AccessTicketDriverUpsells = (props: {driver: ReservationDriver}) => {
    const {t} = useTranslation();
    const {allUpsellItems, availableUpsellsOptions, reservationDriverUpsellItems, setAllItems} = useAssignedItems(props.driver);
    const selectedReservation = useTypedSelector(state => state.bookingLoginState.selectedReservation);

    useEffect(() => {
        setAllItems();
    }, [props.driver]);

    // console.log(availableUpsellsOptions, reservationDriverUpsellItems);

    return (
        // <div className={"AccessTicketDriverUpsells flex flex-col gap-y-3"}>
        <div className={"AccessTicketDriverUpsells flex flex-col"}>
            {(reservationDriverUpsellItems.length > 0 || allUpsellItems.length > 0 || availableUpsellsOptions.length > 0) && (
                <h3 className={"font-semibold text-xs md:text-base pb-[20px] md:pb-[27px] text-black"}>{t("Upsells")}</h3>
            )}
            {/*those that are not assigned to the reservationDriver*/}
            <div className={"flex flex-col md:grid w-full gap-y-[20px] md:gap-y-[32px] gap-x-[20px] md:gap-x-[54px]"}>
                {allUpsellItems.map((option, i) => (
                    // count and used_count are deliberately sent, to prevent rerendering
                    <AccessTicketDriverUpsell
                        key={i}
                        driver={props.driver}
                        option={option}
                        count={option.count}
                        package_item_id={option.package_item_id}
                        used_count={option.used_count}
                    />
                ))}
                {reservationDriverUpsellItems.length == 0 && availableUpsellsOptions.length == 0 && (
                    <p className={"text-xs text-gray-500"}>{t("No other upsells available")}</p>
                )}
            </div>
        </div>
    );
};

export default AccessTicketDriverUpsells;
